<div *ngIf="type == 'image'">
  <div data-toggle="modal" #imageModal data-target="#preview-image"></div>
  <div class="thumbnail">
    <div class="attachment-block">
      <img (click)="showImage(attachment.url)" [src]="attachment.url" />
      <div *ngIf="canDeleteMedia()" class="thumbnail-delete">
        <a (click)="deleteAsset(attachment.id)"><i class="fa fa-times"></i></a>
      </div>
    </div>
  </div>
</div>

<div *ngIf="type == 'document'" class="file-block">
  <span class="file-name">
    <a [href]="attachment.url" target="_blank">
      <span class="name">{{ getAttachmentName() }}</span>
    </a>
    <span *ngIf="canDeleteMedia()" (click)="deleteAsset(attachment.id)" class="file-delete"
      ><i class="fal fa-times fa-sm"></i
    ></span>
  </span>
</div>
